import React from "react";
import "./styles.css";

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      © 2024 Pranav Vijay. All Rights Reserved.
    </footer>
  );
};

export default Footer;
